import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { t } = useLang();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [slug, setSlug] = useState("");
  const [programId, setProgramId] = useState("");

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setSlug(data.course_slug || "");
        setProgramId(data.program_id || "");
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) {
          setState("failed");
          return;
        }
      } catch {
        /* keep polling */
      }
      if (tries >= 15) {
        setState("pending");
        return;
      }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-5 pt-24 pb-24 text-center" data-testid="payment-success-page">
      {state === "checking" && (
        <>
          <Loader2 className="w-10 h-10 text-[#1D4ED8] mx-auto animate-spin" />
          <p className="text-base font-semibold text-[#0B1B3A] mt-6" data-testid="payment-checking">{t("payment.checking")}</p>
        </>
      )}
      {state === "paid" && (
        <>
          <CheckCircle2 className="w-12 h-12 text-[#16A34A] mx-auto" />
          <h1 className="font-heading font-black text-3xl text-[#0B1B3A] mt-6" data-testid="payment-paid">{t("payment.success")}</h1>
          <p className="text-sm text-[#475569] mt-3">{t("payment.accessGranted")}</p>
          <Link data-testid="payment-go-course" to={programId ? `/courses/${programId}` : slug ? `/academy/${slug}` : "/courses"} className="btn-blue mt-8 inline-flex">
            {t("payment.startNow")}
          </Link>
        </>
      )}
      {state === "pending" && (
        <>
          <Loader2 className="w-10 h-10 text-[#EA580C] mx-auto" />
          <p className="text-base font-semibold text-[#0B1B3A] mt-6" data-testid="payment-pending">{t("payment.pending")}</p>
          <Link to="/academy" className="btn-outline-light mt-7 inline-flex">{t("academy.backToCatalog")}</Link>
        </>
      )}
      {state === "failed" && (
        <>
          <XCircle className="w-12 h-12 text-[#B91C1C] mx-auto" />
          <p className="text-base font-semibold text-[#0B1B3A] mt-6" data-testid="payment-failed">{t("payment.failed")}</p>
          <Link to="/academy" className="btn-blue mt-7 inline-flex">{t("academy.backToCatalog")}</Link>
        </>
      )}
    </div>
  );
}
